import axios from 'axios';
const url = 'https://covid19.mathdro.id/api';
export const fetchData = async (country) => {
	let selectedUrl = country ? `${url}/countries/${country}` : url;
	try {
		const {
			data: { confirmed, recovered, deaths, lastUpdate },
		} = await axios.get(selectedUrl);
		return { confirmed, recovered, deaths, lastUpdate };
	} catch (error) {
		console.log(error);
	}
};

export const fetchDailyData = async () => {
	try {
		const { data } = await axios.get(`${url}/daily`);
		const modifiedData = data.map(({ confirmed, deaths, reportDate: date }) => ({
			confirmed: confirmed.total,
			deaths: deaths.total,
			date,
		}));
		/*console.log(modifiedData.map((data) => data.deaths));*/
		return modifiedData;
	} catch (error) {
		return error;
	}
};

export const fetchCountries = async () => {
	try {
		const {
			data: { countries },
		} = await axios.get(`${url}/countries`);
		return countries.map((country) => country.name);
	} catch (error) {
		return error;
	}
};
